module.exports = __webpack_public_path__ + "static/media/monkeyisland2.22adec23.gif";